import React from 'react';
import styles from './InfoCard.module.scss';

type InfoData = string | number | Array<unknown> | { value?: unknown; count?: number } | null | undefined;

export type InfoCardProps = {
    title: string;
    description?: string;
    data?: InfoData;
} & React.HTMLAttributes<HTMLDivElement>;

const InfoCard = ({ title, description, data, ...props }: InfoCardProps) => {
    const getValue = (): string => {
        if (!data) return '0';

        // Handle the specific case where data is an array containing objects with a value array
        if (Array.isArray(data) && data.length > 0 && data[0] && typeof data[0] === 'object') {
            const firstItem = data[0] as Record<string, unknown>;
            if ('value' in firstItem && Array.isArray(firstItem.value)) {
                return firstItem.value.length.toString();
            }
        }

        // If data is an array, return its length
        if (Array.isArray(data)) {
            return data.length.toString();
        }

        // If data is a complex object with a value property
        if (typeof data === 'object' && data !== null) {
            const dataObj = data as Record<string, unknown>;
            if ('value' in dataObj) {
                if (Array.isArray(dataObj.value)) {
                    return dataObj.value.length.toString();
                }
                return String(dataObj.value);
            }
            if ('count' in dataObj) return String(dataObj.count);
            return '0';
        }

        // If data is already a number or string
        return String(data);
    };

    return (
        <div className={styles.infoCard} {...props}>
            <h3>{title}</h3>
            <p>
                <span className={styles.infoValue}>{getValue()}</span>
                {description}
            </p>
        </div>
    );
};

export default InfoCard;
